import { redirect, type RouteObject } from 'react-router';

import { lazyComponent } from '../../../lazy-component';
import { uiKitLoader } from './ui-kit-loader';

const uiKit = (name: string) =>
  lazyComponent(() => import('@pages/shared/ui-kit-page'), name);

export const uiKitRoutes: RouteObject = {
  loader: uiKitLoader,
  children: [
    {
      path: '/ui-kit',
      lazy: uiKit('UiKitPage'),
      children: [
        { index: true, loader: () => redirect('/ui-kit/tab-filter') },
        { path: 'product-icon', lazy: uiKit('ProductIconPage') },
        { path: 'chip-selector', lazy: uiKit('ChipSelectorPage') },
        { path: 'selectable-option-item', lazy: uiKit('SelectableOptionItemPage') },
        { path: 'segmented-control', lazy: uiKit('SegmentedControlPage') },
        { path: 'date-range-filter', lazy: uiKit('DateRangeFilterPage') },
        { path: 'text-range-filter', lazy: uiKit('TextRangeFilterPage') },
        { path: 'text-field-filter', lazy: uiKit('TextFieldFilterPage') },
        { path: 'tab-filter', lazy: uiKit('TabFilterPage') },
        { path: 'list-filter', lazy: uiKit('ListFilterPage') },
        { path: 'multiline-text-filter', lazy: uiKit('MultilineTextFilterPage') },
        { path: 'amount-range-filter', lazy: uiKit('AmountRangeFilterPage') },
        { path: 'segment-filter', lazy: uiKit('SegmentFilterPage') },
        { path: 'snackbar', lazy: uiKit('SnackbarPage') },
        { path: 'accordion', lazy: uiKit('AccordionPage') },
        { path: 'card', lazy: uiKit('CardPage') },
        { path: 'button', lazy: uiKit('ButtonPage') },
        { path: 'button-group', lazy: uiKit('ButtonGroupPage') },
        { path: 'checkbox', lazy: uiKit('CheckboxPage') },
        { path: 'chip', lazy: uiKit('ChipPage') },
        { path: 'dialog', lazy: uiKit('DialogPage') },
        { path: 'dropdown', lazy: uiKit('DropdownPage') },
        { path: 'icon-button', lazy: uiKit('IconButtonPage') },
        { path: 'icons', lazy: uiKit('IconsPage') },
        { path: 'linear-progress', lazy: uiKit('LinearProgressPage') },
        { path: 'paper', lazy: uiKit('PaperPage') },
        { path: 'phone-text-field', lazy: uiKit('PhoneTextFieldPage') },
        { path: 'radio', lazy: uiKit('RadioPage') },
        { path: 'search-panel', lazy: uiKit('SearchPanelPage') },
        { path: 'select', lazy: uiKit('SelectPage') },
        { path: 'slider', lazy: uiKit('SliderPage') },
        { path: 'split-button', lazy: uiKit('SplitButtonPage') },
        { path: 'switch', lazy: uiKit('SwitchPage') },
        { path: 'table', lazy: uiKit('TablePage') },
        { path: 'table-grouping', lazy: uiKit('TableGroupingPage') },
        { path: 'tabs', lazy: uiKit('TabsPage') },
        { path: 'text-field', lazy: uiKit('TextFieldPage') },
        { path: 'toggle-button-group', lazy: uiKit('ToggleButtonGroupPage') },
        { path: 'tooltip', lazy: uiKit('TooltipPage') },
        { path: 'typography', lazy: uiKit('TypographyPage') },
      ],
    },
  ],
};
